<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("data-category.new") }}</span>
      </h2>

      <!-- form input start-->
      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('data-category.text')"
      />

      <br />

      <div class="checkbox1">
        <b-form-checkbox v-model="form.personalData" class="custom-checkbox mb-3" checked>
          Kişisel Veri
        </b-form-checkbox>
      </div>

      <div class="checkbox2">
        <b-form-checkbox v-model="form.specialQualityData" class="custom-checkbox mb-3" checked>
          Özel Nitelikli Veri
        </b-form-checkbox>
      </div>

      <!-- <h6 class="mt-2">{{ $t("data-category.risk-effect-value") }}</h6>
      <select class="form-control" v-model="form.riskEffectValue">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
      </select> -->

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  data() {
    return {
      form: {
        name: undefined,
        specialQualityData: false,
        personalData: false,
        // riskEffectValue: 1,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      // riskEffectValue: {
      //   required,
      // },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationDataCategory/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationDataCategory/editedEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationDataCategory/isEditMode"];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch("organizationDataCategory/save", this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-category");
        }
        setTimeout(() => this.$emit("onSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
